import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmployeesService {
  private apiUrl = environment.apiUrl; 
  constructor(private http: HttpClient) {}
  
  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    
    return this.http.post(`${this.apiUrl}v1/employees`, formData).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to upload file', err);
        return throwError(() => new Error('File upload failed'));
      }),
    );
  }

  markAsSeen(candidateId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}v1/employees/mvr/mark-as-seen`, { candidate_id: candidateId }).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to mark as seen', err);
        return throwError(() => new Error('Marking as seen failed'));
      }),
    );
  }

  loadEmployees(currentPage: number, perPage: number, filters: any={}, show_all=false, sort_by='name', sort_order='asc'): Observable<any> {
    const params = { page: currentPage.toString(), per_page: perPage.toString(), ...filters, show_all: show_all.toString(), sort_by, sort_order };
    return this.http.get<any>(`${this.apiUrl}v1/employees`, { params }).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to load employees', err);
        return of({ list: [], total: 0 });
      }),
    );
  }

  getPendingMvrRenewalsPayload(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}v1/employees/pending-mvr-renewals-payload`).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to fetch pending MVR renewals', err);
        return of({});
      }),
    );
  }

  getPendingIdvMvrPayload(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}v1/employees/pending-idv-mvr-payload`).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to fetch pending ID Verification + MVR payload', err);
        return of({});
      }),
    );
  }

  triggerPendingMvrRenewals(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}v1/scheduled-rules`, payload).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to trigger pending MVR renewals', err);
        return throwError(() => new Error('Triggering pending MVR renewals failed'));
      }),
    );
  }

  archiveEmployee(candidateId: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}v1/employees/${candidateId}/archive`, {}).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to archive employee', err);
        return throwError(() => new Error('Archiving employee failed'));
      }),
    );
  }

  unarchiveEmployee(candidateId: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}v1/employees/${candidateId}/unarchive`, {}).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to unarchive employee', err);
        return throwError(() => new Error('Unarchiving employee failed'));
      }),
    );
  }
}